export const createSwalLoaderNode = () => {
  const loaderContainer = document.createElement("div");
  loaderContainer.style.display = "flex";
  loaderContainer.style.alignItems = "center";
  loaderContainer.style.justifyContent = "center";
  loaderContainer.style.marginTop = "12px";
  loaderContainer.innerHTML = `
    <svg
      width="40"
      height="40"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Loading"
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="var(--hrms-primary-blue-end, #036dda)"
        stroke-width="4"
        stroke-linecap="round"
        stroke-dasharray="31.415, 31.415"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  `;

  return loaderContainer;
};
